import { httpClient } from '@/services/http/httpClient'
import { getQueryParams, type QueryParams } from '@/utils/queryParams'

import type { PortfolioProject } from '../getPortfolioProject'

type GetPortfolioProjectData = {
  query: QueryParams
}

export type ListPortfolioProject = Omit<
  PortfolioProject,
  'steps' | 'horizontTagProject' | 'riscTagProject'
>

type PortfolioProjectResponse = {
  projects: ListPortfolioProject[]
  paginate: {
    total: number
    page: number
    pages: number
    limit: number
  }
}
export async function getPortfolioProjects({ query }: GetPortfolioProjectData) {
  const queryParams = getQueryParams(query)

  const { data } = await httpClient.get<PortfolioProjectResponse>(
    `/projects/portfolio-projects/list?${queryParams}`,
  )

  return data
}
